export default __webpack_public_path__ + "static/media/infographic-queue.4157ea3f.svg";